import RouteBase from '@/router/routes/RouteBase.js';

class RoutesMagnum {
  subFolderPath = '/businessPartners/magnum';
  isPublic = false;

  Home = new RouteBase({
    name: 'magnum-home',
    path: '',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Home',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: {
        isCollapsable: false,
        icon: 'wave',
        title: 'Magnum',
        hasBackButton: true,
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Magnum',
        },
      ],
    },
  });

  Brand = new RouteBase({
    name: 'brand',
    path: ':brand/:id',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Brand',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Magnum',
          link: '/secure/business-partners/magnum',
        },
        {
          name: 'Kategori',
        },
      ],
    },
  });

  List = new RouteBase({
    name: 'list',
    path: 'price-list',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'List',
    isPublic: this.isPublic,
    meta: {
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Magnum',
          link: '/secure/business-partners/magnum',
        },
        {
          name: 'Güncel Fiyat Listesi',
        },
      ],
    },
  });
}

export default new RoutesMagnum();
